<div class="dropdown" dropdown #dropdown="bs-dropdown" *ngIf="!loading && tenants.length > 1" [insideClick]="true">
    <button id="tenant-select-dropdown-btn" dropdownToggle type="button" class="btn btn-link dropdown-toggle font-weight-bold tenant-name"
       aria-controls="language-select-dropdown-list">
    {{ currentTenant?.name }}
    </button>
    <ul class="dropdown-menu dropdown-menu-right px-2 shadow-sm" *dropdownMenu role="menu" >
        <li [formGroup]="form">
          <kupari-input formControlName="search" [label]="'search.search_criteria'" [clearable]="true"></kupari-input>
        </li>
        <li *ngFor="let tenant of filteredTenants">
            <button type="button" class="dropdown-item px-0" (click)="chooseTenant(tenant.id)">
                {{tenant.name}}
            </button>
        </li>
    </ul>
</div>
<div *ngIf="!loading && tenants.length == 1" class="font-weight-bold tenant-name">
    {{ currentTenant?.name }}
</div>
